import ApiService from './api';

// Analytics API service
class AnalyticsService {
  // Get dashboard overview analytics
  static async getDashboardAnalytics(period = '30d') {
    try {
      const response = await ApiService.get('/analytics/dashboard', { period });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get dashboard stats for the dashboard page
  static async getDashboardStats() {
    try {
      const response = await ApiService.get('/analytics/dashboard-stats');
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get sales trend data
  static async getSalesTrend(period = '6m') {
    try {
      const response = await ApiService.get('/analytics/sales-trend', { period });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get car categories breakdown
  static async getCarCategories() {
    try {
      const response = await ApiService.get('/analytics/car-categories');
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get quick stats for today
  static async getQuickStats() {
    try {
      const response = await ApiService.get('/analytics/quick-stats');
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get recent activity
  static async getRecentActivity(limit = 10) {
    try {
      const response = await ApiService.get('/analytics/recent-activity', { limit });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get sales analytics
  static async getSalesAnalytics(period = '12m') {
    try {
      const response = await ApiService.get('/analytics/sales', { period });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get user analytics
  static async getUserAnalytics(period = '30d') {
    try {
      const response = await ApiService.get('/analytics/users', { period });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get car analytics
  static async getCarAnalytics(period = '30d') {
    try {
      const response = await ApiService.get('/analytics/cars', { period });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get revenue analytics
  static async getRevenueAnalytics(period = '12m') {
    try {
      const response = await ApiService.get('/analytics/revenue', { period });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get platform analytics
  static async getPlatformAnalytics(period = '30d') {
    try {
      const response = await ApiService.get('/analytics/platform', { period });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get geographic analytics
  static async getGeographicAnalytics(period = '30d') {
    try {
      const response = await ApiService.get('/analytics/geographic', { period });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get traffic analytics
  static async getTrafficAnalytics(period = '30d') {
    try {
      const response = await ApiService.get('/analytics/traffic', { period });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get conversion analytics
  static async getConversionAnalytics(period = '30d') {
    try {
      const response = await ApiService.get('/analytics/conversion', { period });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get top performing analytics
  static async getTopPerformingAnalytics(period = '30d') {
    try {
      const response = await ApiService.get('/analytics/top-performing', { period });
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get real-time analytics
  static async getRealTimeAnalytics() {
    try {
      const response = await ApiService.get('/analytics/real-time');
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Get custom analytics with filters
  static async getCustomAnalytics(filters) {
    try {
      const response = await ApiService.post('/analytics/custom', filters);
      return response;
    } catch (error) {
      throw error;
    }
  }

  // Export analytics data
  static async exportAnalytics(type, period, format = 'csv') {
    try {
      const filename = `${type}_analytics_${period}.${format}`;
      const response = await ApiService.download(
        `/analytics/export?type=${type}&period=${period}&format=${format}`,
        filename
      );
      return response;
    } catch (error) {
      throw error;
    }
  }
}

export default AnalyticsService;